module.exports = __webpack_public_path__ + "img/Jump Casting55.8e480c88.jpg";